export function Footer() {
  return (
    <footer className="bg-ink text-gray-400 py-8 text-center font-mono text-xs">
      <p>© {new Date().getFullYear()} Diagnostic Intelligence. All rights reserved.</p>
      <p className="mt-2 text-gray-600">
        Multimodal Clinical AI · SaMD · Acoustic · Radiology · Pathology · Precision Medicine
      </p>
    </footer>
  );
}
